import { useState, useEffect } from 'react';
import { anotherInstance } from './hookConnect';

const VideoPostTable = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0);
    const [isDataFullyLoaded, setIsDataFullyLoaded] = useState(false);

    const reloadData = () => {
        setRefreshKey(prevKey => prevKey + 1);
    };

    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();

        const fetchData = async () => {
            try {
                setLoading(true);
                setError(null);
                setIsDataFullyLoaded(false);
                
                const response = await anotherInstance.get(`analyst/video/get`, {
                    signal: controller.signal,
                    timeout: 30000 // 30 секунд таймаут
                });
                
                if (!isMounted) return;
                
                if (response.data?.data) {
                    setData(response.data.data);
                    setIsDataFullyLoaded(true);
                } else {
                    setData([]);
                    setError('Неверный формат данных');
                }
            } catch (err) {
                if (!isMounted) return;
                setError(`Ошибка загрузки: ${err.message}`);
                setData([]);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        fetchData();

        return () => {
            isMounted = false;
            controller.abort();
        };
    }, [refreshKey]);

    return { data, loading, error, reloadData, isDataFullyLoaded };
};

export default VideoPostTable;